import { type ModelEntry, providerModelRegistry } from "./constants"
import type { HarnessId } from "./providerEvents/harnessEventTypes"

export function shouldHideModelInPicker(_model: ModelEntry, _harnessId: HarnessId): boolean {
    return false
}

export function getVisibleModelEntries(harnessId: HarnessId): ModelEntry[] {
    return providerModelRegistry.getVisibleModelEntries(harnessId)
}

export function getVisibleModelId(value: string, harnessId: HarnessId): string {
    return providerModelRegistry.getVisibleModelId(value, harnessId)
}
